import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdPushReportsRecipientSuspense } from "api/generated/users/users";

export function usePushReportsRecipientForUserQuery(userId: number) {
    return useGetUsersUserIdPushReportsRecipientSuspense(userId, {
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
